{
  "Announcements": "お知らせ",
  "MarkAllAsRead": "すべて既読としてマーク",
  "NoLinkNotification": "この通知に利用可能なリンクはありません",
  "Notification": "通知",
  "ViewAll": "すべて表示"
}
